import dataStatistics from './dataStatistics'
export default [
  {
    path: '/memberCardManageAll',
    component: () => import('../pages/memberCardManage/memberCardManage.vue'),
    name: 'memberCardManageAll',
    title: '会员卡管理中心',
    meta: {
      title: '会员卡管理中心',
    },
  },
  {
    path: '/menberCheckManageAll',
    component: () => import('../pages/memberCardManage/menberCheckManage.vue'),
    name: 'menberCheckManageAll',
    title: '会员审核',
    meta: {
      title: '会员审核',
    },
  },
  {
    path: '/memberCodeRecordAll',
    component: () => import('../pages/memberCardManage/memberCodeRecord.vue'),
    name: 'memberCodeRecordAll',
    title: '会员用卡记录',
    meta: {
      title: '会员用卡记录',
    },
  },
  {
    path: '/memberRenewAll',
    component: () => import('../pages/memberCardManage/memberRenew.vue'),
    name: 'memberRenewAll',
    title: '会员续卡记录',
    meta: {
      title: '会员续卡记录',
    },
  },
  {
    path: '/activateCard',
    component: () => import('../pages/memberCardManage/cardManage.vue'),
    name: 'activateCard',
    title: '会员卡管理',
    meta: {
      title: '会员卡管理',
    },
  },
  {
    path: '/viceCardManage',
    component: () => import('../pages/memberCardManage/viceCardManage.vue'),
    name: 'viceCardManage',
    title: '副卡管理',
    meta: {
      title: '副卡管理',
    },
  },
  {
    path: '/memberCardCategory',
    component: () =>
      import('../pages/memberCardManage/v2/memberCardCategory.vue'),
    name: 'memberCardCategory',
    title: '会员卡分类',
    meta: {
      title: '会员卡分类',
    },
  },
  {
    path: '/employeesManage',
    component: () => import('../pages/memberCardManage/v2/employeesManage.vue'),
    name: 'employeesManage',
    title: '员工管理',
    meta: {
      title: '员工管理',
    },
  },
  {
    path: '/cardRightsManage',
    component: () =>
      import('../pages/memberCardManage/v2/cardRightsManage.vue'),
    name: 'cardRightsManage',
    title: '卡权益管理',
    meta: {
      title: '卡权益管理',
    },
  },
  {
    path: '/memberBaseInfo',
    component: () => import('../pages/memberCardManage/v2/memberBaseInfo.vue'),
    name: 'memberBaseInfo',
    title: '会员基本信息',
    meta: {
      title: '会员基本信息',
    },
  },
  {
    path: '/departmentMealCard',
    component: () =>
      import('../pages/memberCardManage/v2/departmentMealCard.vue'),
    name: 'departmentMealCard',
    title: '部门餐卡设置',
    meta: {
      title: '部门餐卡设置',
    },
  },
  {
    path: '/mealCardDeductRecord',
    component: () =>
      import('../pages/memberCardManage/v2/mealCardDeductRecord.vue'),
    name: 'mealCardDeductRecord',
    title: '餐卡扣除记录',
    meta: {
      title: '餐卡扣除记录',
    },
  },
  {
    path: '/dataStatistics',
    component: () =>
      import('../pages/memberCardManage/dataStatistics/dataStatistics.vue'),
    name: 'dataStatistics',
    title: '数据分析',
    redirect: '/dataStatistics/userConsumeRank',
    meta: {
      title: '数据分析',
    },
    children: dataStatistics,
  },
]
